import { render, staticRenderFns } from "./message_item_dialog.vue?vue&type=template&id=cd9e38e2"
import script from "./message_item_dialog.vue?vue&type=script&lang=js"
export * from "./message_item_dialog.vue?vue&type=script&lang=js"
import style0 from "./message_item_dialog.vue?vue&type=style&index=0&id=cd9e38e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports